import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";


export default function PerfilGasesSalidaTE() {
  const [flujosSolidosSTE, setFlujosSolidosSTE] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [caudalGasSTE, setCaudalGasSTE] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeN2STE, setPorcentajeN2STE] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentaje02STE, setPorcentaje02STE] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeH20STE, setPorcentajeH20STE] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeS2STE, setPorcentajeS2STE] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeS02STE, setPorcentajeS02STE] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeAs2S3STE, setPorcentajeAs2S3STE] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeAs4O6STE, setPorcentajeAs4O6STE] = useState({
    value: [],
    fecha: [],
    estado: [],
  });


  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 35,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateFlujosSolidosSTE(data);
    populateCaudalGasSTE(data);
    populatePorcentajen2STE(data);
    populatePorcentaje02STE(data);
    populatePorcentajeH20STE(data);
    populatePorcentajeS2STE(data);
    populatePorcentajeS02STE(data);
    populatePorcentajeAs2S3STE(data);
    populatePorcentajeAs4O6STE(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateFlujosSolidosSTE(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Flujo de Sólidos Salida TE"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setFlujosSolidosSTE({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaudalGasSTE(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Caudal de Gas Salida TE"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCaudalGasSTE({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajen2STE(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%N2 Salida TE"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeN2STE({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentaje02STE(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%O2 Salida TE"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentaje02STE({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeH20STE(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%H2O Salida TE"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeH20STE({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeS2STE(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%S2 Salida TE"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeS2STE({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeS02STE(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%SO2 Salida TE"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeS02STE({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeAs2S3STE(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%As2S3 Salida TE"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeAs2S3STE({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeAs4O6STE(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%As4O6 Salida TE"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeAs4O6STE({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil de Gases Salida TE"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Flujo de Sólidos Salida TE --------------------------------------- */}
            <Chart.Line
              name="Flujo de Sólidos Salida TE"
              data={flujosSolidosSTE.value}
              yAxis={0}
            />
            {/** -------------------------------- Caudal de Gas Salida TE --------------------------------------- */}
            <Chart.Line
              name="Caudal de Gas Salida TE"
              data={caudalGasSTE.value}
              yAxis={0}
            />
            {/** -------------------------------- %N2 Salida TE --------------------------------------- */}
            <Chart.Line
              name="%N2 Salida TE"
              data={porcentajeN2STE.value}
              yAxis={1}
            />
            {/** -------------------------------- %O2 Salida TE --------------------------------------- */}
            <Chart.Line
              name="%O2 Salida TE"
              data={porcentaje02STE.value}
              yAxis={1}
            />
            {/** -------------------------------- %H2O Salida TE --------------------------------------- */}
            <Chart.Line
              name="%H2O Salida TE"
              data={porcentajeH20STE.value}
              yAxis={1}
            />
            {/** -------------------------------- %S2 Salida TE --------------------------------------- */}
            <Chart.Line
              name="%S2 Salida TE"
              data={porcentajeS2STE.value}
              yAxis={1}
            />
            {/** -------------------------------- %SO2 Salida TE --------------------------------------- */}
            <Chart.Line
              name="%SO2 Salida TE"
              data={porcentajeS02STE.value}
              yAxis={1}
            />
            {/** -------------------------------- %As2S3 Salida TE --------------------------------------- */}
            <Chart.Line
              name="%As2S3 Salida TE"
              data={porcentajeAs2S3STE.value}
              yAxis={1}
            />
            {/** -------------------------------- %As4O6 Salida TE --------------------------------------- */}
            <Chart.Line
              name="%As4O6 Salida TE"
              data={porcentajeAs4O6STE.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={flujosSolidosSTE.fecha} />

            <Chart.YAxis
              labelSuffix=" Nm3/h"
              title="Caudal de Gases, Nm3/h"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={80000}
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido, %"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
              max={80}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
